(function($) {

var pageId = 'page-new-calendar',
    page = '#' + pageId;

$(function() {
    $('body')
        .on( "click", page + " .link-cal-color", function(e) {
            e.preventDefault();
            var link = $(this).addClass("selected");
            var form = link.closest(".form");

            link.siblings(".link-cal-color")
                .removeClass("selected");

            form.find("input[name=calendar_color]")
                .val(link.data("color"));
        })
        .on('ajax:beforeSend', page + ' form#form-new-calendar', function(e, xhr, settings) {
            // set ajax param members
            var membersGuid = $('.member.selected').map(function() {
                return $(this).data('guid');
            }).get();

            membersGuid.push(tower.me.guid);

            var membersParam = '';
            $.each(membersGuid, function(i, guid) {
                membersParam += '&member_guids[]=' + guid;
            });

            settings.data += membersParam;
        })
        .on('ajax:success', page + ' .form#form-new-calendar', function(e, result) {
            if (tower.calendars) {
                var calIndex = -1;
                $.each(tower.calendars, function(i, c) {
                    if (c.guid === result.calendar.guid) {
                        calIndex = i;
                        return false;
                    }
                });

                if (calIndex < 0) {
                    tower.calendars.push(result.calendar);
                } else {
                    tower.calendars[i] = result.calendar;
                }
            }

            var eventFilter = simple.util.storage.get('calEventFilter_' + tower.team.guid);
            simple.util.storage.set('calEventFilter_' + tower.team.guid, eventFilter + (eventFilter ? ',' : '') + result.calendar.guid);

                if ( $("input[name=set_as_leave_calendar]").length != 0 ) {
                    tower.stack.load('/teams/' + tower.team.guid + '/set_leave_calendar/', {
                        nocache: true,
                        replace: true
                    });
                } else {
                    tower.stack.load('/teams/' + tower.team.guid + '/calendars/', {
                        root: true,
                        fluid: true
                    });
                }
        });
});

$(document).on('pjaxload#' + pageId, function(e, $page, page) {
    if ($page.is( "[data-archived], [data-deleted]" )) {
        $( "#btn-save-calendar" ).attr( "disabled", "disabled" );
    }

    tower.initManageMembers($page);

    // 新建请假日历时默认选择所有人
    if (location.search.indexOf('name')) {
        $page.find('.group-select .all').trigger('click');
    }
});


})(jQuery);

